import CBOClient from "./cbo-client";

class BaseApi {
    constructor(baseEndpoint) {
        this._client = new CBOClient(baseEndpoint);
    }

    cancel() {
        this._client.cancel();
    }
}

BaseApi.DEFAULT_LIMIT = 300;
export default BaseApi;
